<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 841.89 595.28"
    style="enable-background: new 0 0 841.89 595.28"
    xml:space="preserve"
    class="cplug-icon"
  >
    <g>
      <path
        class="logo-text-on-color"
        d="M443.34,378.47c0,6.92,4.26,9.57,13.3,9.57h9.05l6.12,35.65c-7.98,4.79-28.73,6.92-39.1,6.92
        c-27.93,0-44.96-13.83-44.96-37.24v-152.7h55.6V378.47z"
      />
      <path
        class="logo-text-on-color"
        d="M618.11,426.89h-43.89l-5.05-19.41c-17.29,15.7-33.79,23.14-53.21,23.14c-26.07,0-39.37-12.77-39.37-37.24v-99.49h55.87
        v81.67c0,5.85,2.93,8.24,9.84,8.24c5.85,0,11.17-0.53,19.69-3.19v-86.72h56.13V426.89z"
      />
      <path
        class="logo-text-on-color"
        d="M761.48,316.75c1.6,4.52,2.13,9.58,2.13,15.43c0,30.86-17.82,42.03-68.37,42.03c-7.18,0-13.83-0.27-19.68-0.8
        c-3.19,3.99-2.13,11.44,7.45,11.97l48.42,3.19c30.33,2.13,42.56,15.43,42.56,41.77c0,37.78-22.88,44.7-76.88,44.7
        c-63.58,0-76.35-10.38-76.35-37.78c0-12.5,4.53-21.28,20.75-28.2c-11.97-12.77-7.18-34.04,7.45-40.97
        c-15.7-6.12-22.35-17.56-22.35-35.91c0-30.59,18.62-42.03,68.9-42.03c15.96,0,28.73,1.07,38.58,3.73h44.69l-2.66,20.48
        L761.48,316.75z M677.41,419.97c-3.46,2.67-4.52,4.53-4.52,8.78c0,6.91,5.05,8.51,23.41,8.51c20.22,0,25.54-1.32,25.54-7.18
        c0-6.65-6.39-7.19-20.75-8.24L677.41,419.97z M711.73,332.18c0-9.31-3.46-11.44-16.49-11.44c-13.04,0-16.76,2.12-16.76,11.44
        c0,9.31,3.72,11.71,16.76,11.71C708.27,343.89,711.73,341.5,711.73,332.18z"
      />
      <path
        class="st0"
        d="M218.67,379.35c-17.68,1.36-34.77,1.57-61.64,1.57c-20.59,0-25.74-9.13-25.74-46.74
        c0-37.61,5.15-46.74,25.74-46.74c27.73,0,41.69,0.25,61.64,0.5v-44.08c-17.56-3.91-32.74-5.6-61.64-5.6
        c-69.35,0-94.78,25.26-94.78,95.91c0,70.65,25.44,95.9,94.78,95.9c26.67,0,44.48-1.6,61.64-5.7V379.35z"
      />
      <path
        class="logo-text-on-color"
        d="M306.35,240.66c-36.71,0-53.2,0.27-77.68,2.66v53.73h29.72c4.96,0,8.99,4.02,8.99,8.99c0,4.97-4.03,9-8.99,9h-29.72v37.58
        h29.72c4.96,0,8.99,4.03,8.99,9c0,4.97-4.03,8.99-8.99,8.99h-29.72v56.28h57.73v-63.31c9.04,1.06,18.62,1.59,27.93,1.59
        c50.28,0,68.1-13.57,68.1-61.98C382.44,254.24,364.61,240.66,306.35,240.66z M305.02,324.47H286.4v-43.09h18.62
        c15.7,0,19.69,4.25,19.69,21.81C324.71,320.21,320.72,324.47,305.02,324.47z"
      />
      <path
        class="st0"
        d="M676.26,120.47c-57.04,0-103.27,33.59-103.27,75.03c0,14.86,5.97,28.69,16.22,40.34l-44.08,58.77l68-39.76
        c17.46,9.81,39.35,15.68,63.14,15.68c57.04,0,103.27-33.59,103.27-75.03C779.54,154.06,733.3,120.47,676.26,120.47z M676.28,245.86
        c-5.21,0-9.42-4.2-9.42-9.41c0-5.21,4.21-9.41,9.42-9.41c5.2,0,9.42,4.2,9.42,9.41C685.69,241.65,681.48,245.86,676.28,245.86z
        M702.69,223.02c-1.47,1.37-3.35,2.02-5.23,2.02c-2.13,0-4.24-0.86-5.79-2.56c-3.93-4.36-9.54-6.85-15.4-6.85
        c-5.96,0-11.45,2.43-15.43,6.83c-2.87,3.21-7.81,3.42-11.01,0.53c-3.17-2.9-3.43-7.81-0.53-11.02
        c6.87-7.59,16.69-11.93,26.97-11.93c10.25,0,20.07,4.37,26.95,11.95C706.12,215.2,705.89,220.13,702.69,223.02z M720.27,203.26
        c-1.52,1.52-3.53,2.27-5.53,2.27c-1.98,0-3.96-0.75-5.48-2.25c-8.83-8.77-20.55-13.62-32.99-13.62c-12.49,0-24.21,4.82-33.01,13.61
        c-3.05,3-7.81,3-11.01-0.07c-3.04-3.04-3.04-7.96,0.02-11c11.75-11.67,27.38-18.12,44-18.12c16.59,0,32.2,6.45,43.97,18.15
        C723.32,195.27,723.32,200.19,720.27,203.26z M737.63,183.67c-1.52,1.59-3.57,2.4-5.6,2.4c-1.96,0-3.89-0.73-5.41-2.18
        c-13.6-13.04-31.49-20.23-50.34-20.23c-18.91,0-36.79,7.18-50.37,20.23c-3.1,2.97-8.04,2.87-11.01-0.23
        c-3-3.13-2.89-8.04,0.2-11.04c16.5-15.84,38.22-24.54,61.18-24.54c22.89,0,44.61,8.74,61.12,24.58
        C740.52,175.63,740.63,180.57,737.63,183.67z"
      />
    </g>
  </svg>
</template>

<style scoped lang="scss">
.cplug-icon {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
}

.st0 {
  fill: var(--primary);
}

.logo-text-on-color {
  fill: var(--foreground);
}
</style>
